/* eslint-disable angular/controller-as */
angular.
module("digiexam").
controller("DxCreateCourseController", function CreateCourseController(
	$scope,
	course,
	faults,
	dxDialog,
	dxLocalize
) {
	"use strict";
	$scope.createCourseInProgress = false;
	$scope.isError = false;
	$scope.errorMessage = "";

	$scope.cancelCreateCourse = function cancelCreateCourse() {
		dxDialog.closeMostRecent();
	};

	$scope.canSubmit = function canSubmit() {
		if ($scope.createCourseInProgress || !$scope.courseTitle || $scope.courseTitle.length < 3) {
			return false;
		}
		return true;
	};

	$scope.createCourse = function createCourse(title) {
		if (!$scope.canSubmit()) {
			return;
		}

		$scope.isError = false;

		$scope.createCourseInProgress = true;

		var courseCreatePromise = course.create(title);
		courseCreatePromise.then(function handleResponse(response) {
			$scope.createCourseInProgress = false;

			if (response.faults) {
				$scope.isError = true;
				if (response.faults.indexOf(faults.NAME_NOT_ALLOWED) >= 0) {
					$scope.errorMessage = dxLocalize.get("TheNameIsNotAllowed");
				} else {
					$scope.errorMessage = dxLocalize.get("UnknownError");
				}
			} else {
				$scope.addCourse({id: response.id, title: title, integrationSource: 0});
				dxDialog.closeMostRecent();
			}
		});
	};
});
